(function ($, Drupal) {

  Drupal.behaviors.manualsSwitch = {
    attach: function (context, settings) {

      $('.js_manuals', context).once('manualsSwitch').each(function () {

        let $el = $(this),
          $btn = $el.find('.manuals__option'),
          $resPixel = $('.js_resolution');

        $btn.on('click', function () {

          let $this = $(this);

          if ($this.hasClass('is-active')) {
            if ($resPixel.css('opacity') < '0.5') {
              $this.removeClass('is-active');
              let $att = $this.attr('data-attr');
              $el.find("[data-wrapper='" + $att + "']").removeClass('is-active');
            }
          }
          else {
            $btn.removeClass('is-active');
            $this.addClass('is-active');
            let $att = $this.attr('data-attr');

            $el.find('.manuals__wrapper').removeClass('is-active');
            $el.find("[data-wrapper='" + $att + "']").addClass('is-active');
          }

        });

        if ($(window).width() < 767 || $resPixel.css('opacity') > '0' ) {
          $btn.eq(0).addClass('is-active');
          let $att = $btn.attr('data-attr');
          $el.find("[data-wrapper='" + $att + "']").addClass('is-active');
        }

      });

    }
  };

})(jQuery, Drupal);
